import {Component} from '@angular/core';
import * as Logger from 'js-logger';

import {VideoTagPlayerComponent} from '@app/player/video-tag-player.component';

const logger = Logger.get('video-tag-player');

const BLACK_POSTER = 'data:image/png;base64,'
    + 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mNgYGAAAAAEAAHI6uv5AAAAAElFTkSuQmCC';

@Component({
    selector: 'siq-video-player',
    styles: [`
        video {
            width: 100%;
            height: 100%;
        }
    `],
    template: `
        <video
            #video
            muted
            playsinline
            preload="auto"
            [poster]="poster"
            [src]="videoSrc"
            [style.visibility]="hidden ? 'hidden' : 'visible'"
            (ended)="onEnded()"
            (canplay)="onCanplay()"
        ></video>
    `,
})
export class VideoPlayerComponent extends VideoTagPlayerComponent {
    readonly poster = BLACK_POSTER;
}
